import withPatchService from './with-patch-service';

export default withPatchService;
